<template>
  <div>
    <el-dialog title="" :visible.sync="dialogshow" width="25%" :before-close="handleClose"
      :close-on-press-escape="false" :close-on-click-modal="false" :show-close="type != '1'">
      <span slot="title">
        <div style="display: flex;justify-content: space-between;padding: 0 20px 0 0;">
          <div class="text-ellipsis">
            <span v-if="type == '3'">收藏我的云盘</span>
            <span v-else style="font-weight: bold;">分享：{{ (title.length == 1 ? title[0].folderName : title.length > 1 ?
              title[0].folderName + ' 等' : '') }}</span>
          </div>
          <div>
            <!-- <span v-if="type == '0'">123</span> -->
          </div>
        </div>
      </span>
      <!-- 分享 -->
      <div class="dialog_box" v-if="type == '0'" style="height: 210px;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="" name="first">
            <span slot="label">
              <div type="primary" style="font-size: 14px;" :underline="false"
                :style="{ color: activeName == 'first' ? '#4E66FF' : '' }">
                <i class="iconfont icon-fenxiang1" :style="{ color: activeName == 'first' ? '#4E66FF' : '' }"></i>
                直接分享
              </div>
            </span>
            <div style="color: #383838;margin-top: 10px;">
              生成公开的分享链接，访问者下载此文件不受任何限制
            </div>
            <div style="margin-top: 10px;">
              <span style="color: #383838;">有效期:</span>
              <span style="color: #4E66FF;font-weight: bold;"> 30 </span>
              <span style="color: #000000;">天(过期后将不可查看)</span>
            </div>
            <div class="btn" @click="createlink('0')">
              生成链接
            </div>
          </el-tab-pane>
          <el-tab-pane label="" name="second">
            <span slot="label">
              <div type="primary" style="font-size: 14px;" :underline="false"
                :style="{ color: activeName == 'second' ? '#4E66FF' : '' }">
                <i class="iconfont icon-phone-lock-line" :style="{ color: activeName == 'second' ? '#4E66FF' : '' }"></i>
                手机密码分享
              </div>
            </span>
            <div style="color: #383838;margin-top: 10px;">访问者通过特定手机的验证码验证，才可下载此文件</div>
            <div class="display_flex_center" style="margin-top: 10px;">
              <div style="width: 70px;">手机号：</div>
              <el-input v-model="input" placeholder="请输入手机号" style=""></el-input>
            </div>
            <div class="btn" @click="createlink('1')">
              生成链接
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="dialog_box" v-if="type == '1'" style="height: 210px;">
        <div class="loading_content">
          <div class="api_loading"></div>
          <div class="loading_text">加载中...</div>
        </div>
      </div>
      <div class="dialog_box" v-if="type == '2'" style="height: 210px;">
        <div class="display_flex_center" style="padding: 10px 0 0 20px;">
          <i class="el-icon-success" style="color:#4E66FF;font-size: 20px;"></i>
          <span style="color:#4E66FF;padding-left: 5px;">成功创建链接~</span>
        </div>
        <div id="example" style="">
          {{ texturl }}
        </div>
        <div style="margin-top: 10px;padding: 0px 0 0 20px;">
          <span style="color: #383838;">有效期:</span>
          <span style="color: #4E66FF;">30</span>
          <span style="color: #000000;">天(过期后将不可查看)</span>
        </div>
        <div class="btn" @click="copy(texturl)">
          复制链接
        </div>
      </div>
      <!-- 收藏 -->
      <div class="dialog_box" v-if="type == '3'" style="height: 500px;">
        <div style="overflow: auto;height: 440px;padding-bottom: 30px">
          <div class="display_flex_center card file" v-for="it in 20"
            style="padding: 10px;justify-content: space-between;margin: 10px 10px;">
            <div class="file_imgorname">
              <img src="../assets/images/jieante.png" alt="" srcset="" style="width: 40px;height: 40px;">
              <span style="padding-left: 10px;">CADEX</span>
            </div>
            <div class="file_sc">收藏</div>
          </div>
        </div>
        <div class="btn_file" @click="addfile">
          创建新文件夹
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: Array,
      default: () => []
    },
    dialogtype: {
      type: String,
      default: '0' //0分享  1分享生成链接中   2分享成功生成链接  
    },
    texturl: {
      type: String,
      default: '' //0分享  1分享生成链接中   2分享成功生成链接  
    },
  },
  watch: {
    dialogVisible: {
      handler(newVal, oldVal) {
        this.dialogshow = newVal
      }
    },
    dialogtype: {
      handler(newVal, oldVal) {
        this.type = newVal
        this.activeName = 'first'
        this.input = ''
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      dialogshow: this.dialogVisible,
      type: this.dialogtype,
      activeName: 'first',
      input: ''
    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    handleClose(done) {
      this.dialogshow = false
      this.$emit('closedialog')
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    // 创建链接
    createlink(it) {
      // 0公共  1私人
      if (it == 0) {
        this.$emit('createlink', 0)
      } else {
        if (this.input == '') {
          this.$message.error('请输入接收者手机号')
          return
        }
        this.$emit('createlink', 1, this.input)
      }
    },
    // 复制
    copy(item) {
      // 创建输入框元素
      const cInput = document.createElement('input')
      // 将需要复制的值赋值给输入框的value值
      cInput.value = item
      // 页面底部添加输入框
      document.body.appendChild(cInput)
      // 选中输入框
      cInput.select()
      // 执行浏览器复制命令
      document.execCommand('copy')
      this.$message({ message: '复制成功', type: 'success' })
      // 移除输入框
      document.body.removeChild(cInput)
    },
    addfile() {
      console.log('创建新的文件夹')
    }
  },
}
</script>
<style lang='less' scoped>
/deep/.el-dialog {
  position: absolute;
  margin-top: 0px !important;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  overflow: hidden;
}

/deep/ .el-dialog__body {
  padding: 0px !important;
}

// 内容
.dialog_box {
  height: 210px;
  background: #F5F6FA;
  position: relative;
}

/deep/ .el-tabs__header {
  background: #fff;
  margin: 0;


  .el-tabs__nav {
    padding: 0 20px 0 20px;
    color: #4E66FF;

    .el-tabs__active-bar {
      left: 20px;
      height: 3px;
      background: #4E66FF;
    }
  }

  .el-tabs__nav-wrap::after {
    padding: 0 20px 0 20px !important;
    background-color: initial;
  }
}

/deep/ .el-tabs__item.is-active {
  color: #4E66FF;
}

/deep/ .el-tabs__item:hover {
  color: #4E66FF;
}

/deep/ .el-tabs__content {
  height: 170px;
  background: #F5F6FA;
  padding: 10px 20px
}

/deep/ .el-input__inner {
  border-radius: 35px;
  background: #fff;
}

.btn {
  width: 50%;
  margin: 20px auto 0 auto;
  background: #4E66FF;
  color: #fff;
  padding: 10px;
  text-align: center;
  border-radius: 20px;
  cursor: pointer;
}

#example {
  padding: 5px;
  border-radius: 2px;
  background: #FAFAFA;
  border: 1px solid #DDDDDD;
  margin: 10px 20px;
}


// 创建新的文件夹
.btn_file {
  width: 150px;
  margin-left: 10px;
  background: #4E66FF;
  color: #fff;
  padding: 10px;
  text-align: center;
  border-radius: 20px;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  left: 10px;
}


.file {
  height: 60px;

  .file_imgorname {}

  .file_sc {
    font-size: 12px;
    width: 50px;
    text-align: center;
    padding: 5px;
    color: #fff;
    background: #4E66FF;
    border-radius: 30px;
    display: none;
  }
}

.file:hover .file_sc {
  display: block;
  cursor: pointer;
}
</style>
